export default __webpack_public_path__ + "static/media/land-of-dreams.c0dd70b7.jpg";